<template>
  <ApplicationsRow two-columns>
    <div>
      <AhOvApplicationCard
        :no-top-left-border="activePartOneIndex === 0"
        :no-top-right-border="activePartOneIndex === 1"
      >
        <template #top-content>
          <GenericH4>Mäklaren</GenericH4>
          <PersonCard
            :name="brokers[0]?.name"
            :address="brokers[0]?.address || ''"
          />

          <MemberSelector
            :items="memberItems"
            :active-index="activePartOneIndex"
            @selectItemIndex="selectBrokerIndex"
          />
        </template>
        <template v-if="activePartOneIndex === 1">
          <h3 class="name capitalize-first">
            {{ brokerCompanyInfo?.name || '' }}
          </h3>
          <CompanyModule :company="brokerCompanyInfo" />
          <hr class="divider" />
          <div class="card-content">
            <GenericH4>Företagets verksamhet</GenericH4>
            <p>{{ brokerCompanyInfo?.activities || '-' }}</p>
          </div>
        </template>
        <template v-else-if="activeBroker">
          <h3 class="name capitalize-first">
            {{ activeBroker.name || '' }}
          </h3>
          <ul class="apartment-info">
            <li><b>E-post:</b> {{ activeBroker.email || '' }}</li>
            <li>
              <b>Personnr.:</b>
              {{ activeBroker.ssn }}
            </li>
            <li>
              <b>Telefonnr.:</b>
              {{ activeBroker.phone }}
            </li>
            <li><b>Adress:</b> {{ activeBroker?.address || '' }}</li>
            <li><b>Postnr.:</b> {{ activeBroker?.postalCode || '' }}</li>
            <li><b>Ort:</b> {{ activeBroker?.city || '' }}</li>
          </ul>
        </template>
      </AhOvApplicationCard>
    </div>
    <div></div>
  </ApplicationsRow>
</template>
<script>
import PersonCard from '@/components/PersonCard.vue';
import MemberSelector from '@/components/MemberSelector.vue';
import AhOvApplicationCard from '@/components/AhOvApplicationCard.vue';
import ApplicationsRow from './ApplicationsRow.vue';
import CompanyModule from './CompanyModule.vue';
import GenericH4 from '@/components/GenericH4.vue';

export default {
  components: {
    CompanyModule,
    PersonCard,
    ApplicationsRow,
    AhOvApplicationCard,
    MemberSelector,
    GenericH4
  },
  props: {
    application: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activePartOneIndex: 0
    };
  },
  computed: {
    memberItems() {
      if (this.activeBroker?.organizationNumber) {
        return [
          ...this.brokers.map(broker => ({
            ...broker,
            label: broker.name
          })),
          {
            label: 'Företaget'
          }
        ];
      }
      return [
        ...this.brokers.map(broker => ({
          ...broker,
          label: broker.name
        }))
      ];
    },
    brokers() {
      return this.application.brokers;
    },
    activeBroker() {
      return this.brokers[0];
    },
    brokerCompanyInfo() {
      return this.getCompanyInfo(this.activeBroker?.organizationNumber);
    }
  },
  methods: {
    getCompanyInfo(orgNr) {
      return this.application.companies[orgNr];
    },
    selectBrokerIndex(index) {
      this.activePartOneIndex = index;
    }
  }
};
</script>
<style scoped>
.divider {
  background-color: #e4e5e8;
  margin: 2rem 0;
  border: none;
  height: 1px;
}

.apartment-info li {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.6;
}
.apartment-info li b {
  font-weight: 600;
}

.check-box {
  font-size: 1.4rem;
  margin-top: 1rem;
  color: var(--color-dark-blue);
}
</style>
